/* EternalBond — stylized rotating gold ring (Three.js), lazy-initialized, WebGL/reduced-motion aware */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function supportsWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) {
      return false;
    }
  }

  function showFallback(root, animate) {
    var canvas = root.querySelector('[data-eb-jewel3d-canvas]');
    var fallback = root.querySelector('[data-eb-jewel3d-fallback]');
    if (canvas) canvas.hidden = true;
    if (fallback) {
      fallback.hidden = false;
      if (animate) fallback.classList.add('is-animated');
    }
  }

  function setupScene(root) {
    var canvas = root.querySelector('[data-eb-jewel3d-canvas]');
    if (!canvas) return;

    var reduced = prefersReducedMotion();
    if (reduced || !supportsWebGL() || !window.THREE) {
      showFallback(root, !reduced);
      return;
    }

    var stage = canvas.parentElement;
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    } catch (e) {
      showFallback(root, true);
      return;
    }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    if ('outputEncoding' in renderer) renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.15;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 6.2);

    var group = new THREE.Group();
    scene.add(group);

    var geometry = new THREE.TorusGeometry(1.35, 0.34, 64, 128);
    var material = new THREE.MeshPhysicalMaterial({
      color: 0xc7a96a,
      metalness: 1,
      roughness: 0.26,
      clearcoat: 0.55,
      clearcoatRoughness: 0.25,
      reflectivity: 1
    });
    var ring = new THREE.Mesh(geometry, material);
    ring.rotation.x = Math.PI / 2.4;
    group.add(ring);

    scene.add(new THREE.AmbientLight(0xffffff, 0.4));

    var key = new THREE.PointLight(0xfff1d6, 2.2, 40);
    key.position.set(3, 2.4, 4);
    scene.add(key);

    var rim = new THREE.PointLight(0xe9d9b8, 1.1, 40);
    rim.position.set(-3, -1.5, -3);
    scene.add(rim);

    var fill = new THREE.PointLight(0xbfd3e8, 0.5, 40);
    fill.position.set(-2, 2, 3);
    scene.add(fill);

    function resize() {
      var w = stage.clientWidth,
        h = stage.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    resize();
    window.addEventListener('resize', resize);

    var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var targetX = 0,
      targetY = 0,
      curX = 0,
      curY = 0;
    if (pointerFine) {
      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        targetX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
        targetY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      });
      stage.addEventListener('mouseleave', function () {
        targetX = 0;
        targetY = 0;
      });
    }

    var clock = new THREE.Clock();
    var rafId = null;
    var running = false;

    function animate() {
      if (!running) return;
      rafId = requestAnimationFrame(animate);
      var t = clock.getElapsedTime();

      group.rotation.y += 0.0032;
      group.position.y = Math.sin(t * 0.6) * 0.08;

      curX += (targetY * 0.22 - curX) * 0.05;
      curY += (targetX * 0.3 - curY) * 0.05;
      group.rotation.x = curX;
      group.rotation.z = curY * 0.4;

      key.position.x = Math.sin(t * 0.35) * 4;
      key.position.z = Math.cos(t * 0.35) * 4 + 1;

      renderer.render(scene, camera);
    }

    function start() {
      if (running) return;
      running = true;
      animate();
    }
    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        },
        { threshold: 0.12 }
      );
      io.observe(stage);
    } else {
      start();
    }

    canvas.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-eb-jewel3d]').forEach(function (root) {
      if (root.dataset.ebJewel3dReady) return;
      root.dataset.ebJewel3dReady = 'true';
      setupScene(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
